module.exports = __webpack_public_path__ + "img/162d9031bc46416f8a6bf56be2648a52.b2202761.png";